(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-welcome-popup')) {
    customElements.define('on-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        var self = this;
        this.overlay = this.querySelector('[data-owp-overlay]');
        // Stang popupen direkt om besokaren visar kopintention medan den ar oppen.
        document.addEventListener('on:popups:block', function () { if (self.opened) self.close(false); });
        /* Läggs en BOGO-produkt (taggen bogo-offer, handtag *-offer) i korgen visas popupen inte. */
        document.addEventListener('cart:update', function (e) {
          var r = e && e.detail && e.detail.resource;
          if (r && Array.isArray(r.items) && r.items.some(function (i) { return /-offer$/.test(i.handle || ''); })) {
            self.bogoCart = true;
            if (self.opened) self.close(false);
          }
        });
        if (!this.overlay) return;
        try { this.i18n = JSON.parse(this.querySelector('[data-owp-i18n]').textContent); } catch (e) { this.i18n = {}; }
        this.pct = this.dataset.percent || '10';
        this.opened = false;

        // Texter
        var badge = this.querySelector('[data-owp-badge]'); if (badge) badge.textContent = this.t('badge');
        var title = this.querySelector('[data-owp-title]'); if (title && !title.textContent.trim()) title.textContent = this.t('heading');
        var sub = this.querySelector('[data-owp-sub]'); if (sub && !sub.textContent.trim()) sub.textContent = this.t('sub');
        var em = this.querySelector('[data-owp-email]'); if (em) em.setAttribute('placeholder', this.t('ph'));
        var ct = this.querySelector('[data-owp-consent-txt]'); if (ct) ct.textContent = this.t('consent');
        var btn = this.querySelector('[data-owp-btn]'); if (btn) btn.textContent = this.t('btn');
        var dm = this.querySelector('[data-owp-dismiss]'); if (dm) dm.textContent = this.t('dismiss');
        var cx = this.querySelector('[data-owp-close]'); if (cx) cx.setAttribute('aria-label', this.t('close'));

        // Lyssnare
        var form = this.querySelector('[data-owp-form]'); if (form) form.addEventListener('submit', function (e) { self.onSubmit(e); });
        var cp = this.querySelector('[data-owp-copy]'); if (cp) cp.addEventListener('click', function () { self.onCopy(); });
        this.querySelectorAll('[data-owp-close], [data-owp-dismiss]').forEach(function (b) { b.addEventListener('click', function () { self.close(true); }); });
        this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(true); });
        /* Esc lyssnar på dokumentet: utan automatiskt fokus ligger fokus utanför popupen. */
        document.addEventListener('keydown', function (e) { if (self.opened && e.key === 'Escape') { e.preventDefault(); self.close(true); } });

        if (this.shouldShow()) this.setupTrigger();
      }

      t(k) { return ((this.i18n && this.i18n[k]) || '').replace(/\{p\}/g, this.pct); }

      shouldShow() {
        var pt = this.dataset.pageType || '';
        if (pt === 'cart' || pt.indexOf('checkout') !== -1) return false;
        /* BOGO-produkt på sidan eller i korgen: välkomstrabatten gäller inte där. */
        if (this.dataset.bogo === '1' || this.bogoCart) return false;
        var target = this.dataset.pageTarget || 'all';
        if (target === 'home' && pt !== 'index') return false;
        if (target === 'product' && pt !== 'product') return false;
        if (target === 'collection' && pt !== 'collection') return false;
        var contains = (this.dataset.urlContains || '').trim();
        if (contains) {
          var parts = contains.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
          var path = location.pathname.toLowerCase();
          var hit = parts.some(function (p) { return path.indexOf(p) !== -1; });
          if (!hit) return false;
        }
        try {
          var freq = this.dataset.frequency || 'once';
          if (freq !== 'always') {
            if (localStorage.getItem('on_wp_done')) return false;
            if (freq === 'once') { if (localStorage.getItem('on_wp_seen')) return false; }
            else if (freq === 'days') {
              var prev = parseInt(localStorage.getItem('on_wp_seen'), 10);
              var days = parseInt(this.dataset.frequencyDays, 10) || 30;
              if (prev && (Date.now() - prev) < days * 86400000) return false;
            } else if (freq === 'session') {
              if (sessionStorage.getItem('on_wp_session')) return false;
            }
          }
        } catch (e) {}
        // Delad grind: max en popup per session, och inga alls efter kopintention.
        if (window.onPopupGate && !window.onPopupGate.canShow('welcome')) return false;
        return true;
      }
      markSeenGate() {
        if (window.onPopupGate) window.onPopupGate.markShown('welcome');
      }
      markSeen() {
        try { localStorage.setItem('on_wp_seen', String(Date.now())); sessionStorage.setItem('on_wp_session', '1'); } catch (e) {}
      }

      setupTrigger() {
        var self = this, mode = this.dataset.triggerMode || 'both', fired = false;
        var d = parseInt(this.dataset.triggerDelay, 10); if (isNaN(d)) d = 30;
        var pctScroll = parseInt(this.dataset.triggerScroll, 10) || 50;

        var tidKlar = false, scrollKlar = false;

        function fire() { if (fired) return; fired = true; cleanup(); self.maybeOpen(0); }

        /* 'both' ar standard. Popupen stangdes ungefar tio ganger for varje gang
           den fylldes i, och orsaken var att ETT villkor racke: nagon som bara
           lage still pa sidan fick den i ansiktet efter sex sekunder. Nu kravs
           bade tid OCH scrolldjup, alltsa nagon som faktiskt last en stund. */
        function provaFyra() {
          if (mode === 'time') { if (tidKlar) fire(); return; }
          if (mode === 'scroll') { if (scrollKlar) fire(); return; }
          if (mode === 'either') { if (tidKlar || scrollKlar) fire(); return; }
          if (tidKlar && scrollKlar) fire();
        }

        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          var pr = h > 0 ? (window.scrollY / h) * 100 : 100;
          if (pr >= pctScroll) { scrollKlar = true; provaFyra(); }
        };

        /* AKTIV tid, inte tid sedan sidladdning. En flik som ligger i bakgrunden
           ska inte rakna ner: da hade popupen legat och vantat pa nagon som inte
           ens tittar pa sidan, och motte dem direkt vid aterkomsten. */
        var aktivMs = 0, sistaTick = Date.now(), tickare = null;
        function tick() {
          var nu = Date.now();
          if (!document.hidden) aktivMs += nu - sistaTick;
          sistaTick = nu;
          if (aktivMs >= d * 1000) {
            tidKlar = true;
            clearInterval(tickare); tickare = null;
            provaFyra();
          }
        }
        function startaTickare() {
          if (tickare) return;
          sistaTick = Date.now();
          tickare = setInterval(tick, 1000);
        }
        document.addEventListener('visibilitychange', function () {
          sistaTick = Date.now();
          if (!document.hidden) startaTickare();
        });
        startaTickare();

        function cleanup() {
          window.removeEventListener('scroll', onScroll);
          if (tickare) { clearInterval(tickare); tickare = null; }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* Oppna aldrig ovanpa nagot annat besokaren redan har framme. Den gamla
         kontrollen letade bara efter product-quiz.is-open, en selektor som inte
         finns kvar i temat, sa i praktiken fanns ingen sparr alls. Listan nedan
         tacker storleksguiden, quizet, bildzoomen och varukorgen. Vi provar
         igen en stund senare i stallet for att ge upp. */
      blockerandeYta() {
        var selektorer = [
          '.on-sg__dialog[open]',
          '.on-sq-overlay',
          'on-size-quiz.is-open',
          'dialog.zoom-dialog[open]',
          '.on-ugc__lb[open]',
          'cart-drawer-component dialog[open]'
        ];
        /* Rektangeln, inte offsetParent: den ar alltid null for position:fixed,
           och bade ladan, quizet och lightboxen ar fixed. */
        for (var i = 0; i < selektorer.length; i++) {
          var el = document.querySelector(selektorer[i]);
          if (!el) continue;
          if (el.tagName === 'DIALOG' && (el.open || el.hasAttribute('open'))) return selektorer[i];
          var c = getComputedStyle(el);
          if (c.display === "none" || c.visibility === "hidden") continue;
          if (el.getBoundingClientRect().height > 0) return selektorer[i];
        }
        return null;
      }

      maybeOpen(tries) {
        if (this.bogoCart) return;
        var self = this;
        if (this.blockerandeYta()) {
          if (tries < 6) setTimeout(function () { self.maybeOpen(tries + 1); }, 10000);
          return;
        }
        this.open();
      }

      open() {
        if (this.opened) return;
        this.opened = true;
        this.markSeen();
        this.markSeenGate();
        this.overlay.hidden = false;
        void this.overlay.offsetWidth;
        this.classList.add('is-open');
        this._prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        /* Omgång 81 (Victor): e-postfältet får aldrig fokus automatiskt. På iPhone öppnade det
           tangentbordet och Safari skrollade sidan. Fältet får fokus först när kunden trycker på det. */
      }
      close(byUser) {
        if (!this.opened) return;
        this.opened = false;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = this._prevOverflow || '';
        var self = this;
        setTimeout(function () { if (!self.opened) self.overlay.hidden = true; }, 300);
      }

      onSubmit(e) {
        e.preventDefault();
        var self = this;
        var emailEl = this.querySelector('[data-owp-email]');
        var consent = this.querySelector('[data-owp-consent]');
        var err = this.querySelector('[data-owp-err]');
        var btn = this.querySelector('[data-owp-btn]');
        var email = (emailEl && emailEl.value || '').trim();
        function fail(m) { if (err) { err.textContent = m; err.hidden = false; } }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail(this.t('err_email'));
        if (consent && !consent.checked) return fail(this.t('err_consent'));
        if (err) err.hidden = true;
        if (btn) btn.disabled = true;

        var company = this.dataset.klaviyoCompany, list = this.dataset.klaviyoList;
        var finish = function () {
          try { localStorage.setItem('on_wp_done', '1'); } catch (e) {}
          var form = self.querySelector('[data-owp-form]'); if (form) form.hidden = true;
          var dm = self.querySelector('[data-owp-dismiss]'); if (dm) dm.style.display = 'none';
          var code = self.dataset.code || '';
          var c = self.querySelector('[data-owp-code]'); if (c) c.textContent = code;
          var dl = self.querySelector('[data-owp-done-lead]'); if (dl) dl.textContent = self.t('done_lead');
          var cp = self.querySelector('[data-owp-copy]'); if (cp) cp.textContent = self.t('copy');
          var hn = self.querySelector('[data-owp-hint]'); if (hn) hn.textContent = self.t('hint');
          var done = self.querySelector('[data-owp-done]'); if (done) done.hidden = false;
        };
        if (!company || !list) { finish(); return; }
        var payload = { data: { type: 'subscription', attributes: { custom_source: 'Welcome Popup', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.ok || r.status === 202) { finish(); }
          else { if (btn) btn.disabled = false; fail(self.t('err')); }
        }).catch(function () { if (btn) btn.disabled = false; fail(self.t('err')); });
      }
      onCopy() {
        var self = this;
        var code = this.dataset.code || '';
        var cp = this.querySelector('[data-owp-copy]');
        var done = function () { if (cp) { cp.textContent = self.t('copied'); setTimeout(function () { cp.textContent = self.t('copy'); }, 1500); } };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quiz"]) return;
  try {
    
  if (!customElements.get('product-quiz')) {
    customElements.define('product-quiz', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        // Singleton: om quizet placerats på flera ställen (t.ex. startsidemall + footer-grupp),
        // låt bara FÖRSTA instansen bli aktiv så det aldrig blir dubbla popups.
        if (window.__onProductQuizActive) return;
        window.__onProductQuizActive = true;
        var self = this;

        this.overlay = this.querySelector('[data-pq-overlay]');
        this.modal = this.querySelector('[data-pq-modal]');
        this.resultStep = this.querySelector('[data-pq-result]');
        this.opened = false;

        try { this.i18n = JSON.parse(this.querySelector('[data-pq-i18n]').textContent); } catch (e) { this.i18n = {}; }
        try { this.quiz = JSON.parse(this.querySelector('[data-pq-quiz]').textContent); } catch (e) { this.quiz = { questions: [] }; }

        this.rewardEnabled = this.dataset.rewardEnabled === '1';
        this.rewardPercent = parseInt(this.dataset.rewardPercent, 10); if (isNaN(this.rewardPercent)) this.rewardPercent = 5;
        this.maxAlts = parseInt(this.dataset.maxAlts, 10); if (isNaN(this.maxAlts)) this.maxAlts = 2;

        this.buildSteps();
        this.qSteps = Array.prototype.slice.call(this.querySelectorAll('[data-pq-step]'));
        this.total = this.qSteps.length;
        this.current = 0;

        this.backBtn = this.querySelector('[data-pq-back]');
        this.nextBtn = this.querySelector('[data-pq-next]');

        // Stegindikator
        this.dotsEl = this.querySelector('[data-pq-dots]');
        if (this.dotsEl) {
          var dh = '';
          for (var d = 0; d < this.total; d++) dh += '<span class="pq__dot"></span>';
          this.dotsEl.innerHTML = dh;
          this.dots = Array.prototype.slice.call(this.dotsEl.querySelectorAll('.pq__dot'));
        } else { this.dots = []; }

        // Statiska texter
        var rb = this.querySelector('[data-pq-restart]'); if (rb) rb.textContent = this.t('restart');
        var br = this.querySelector('[data-pq-browse]'); if (br) br.textContent = this.t('browse');

        // Belöning – statiska texter + lyssnare
        var cons = this.querySelector('[data-pq-reward-consent-txt]'); if (cons) cons.textContent = this.t('reward_consent');
        var rin = this.querySelector('[data-pq-reward-email]'); if (rin) rin.setAttribute('placeholder', this.t('reward_ph'));
        var rbtn = this.querySelector('[data-pq-reward-btn]'); if (rbtn) rbtn.textContent = this.tp('reward_btn');
        var rform = this.querySelector('[data-pq-reward-form]'); if (rform) rform.addEventListener('submit', function (e) { self.onRewardSubmit(e); });
        var rcopy = this.querySelector('[data-pq-reward-copy]'); if (rcopy) rcopy.addEventListener('click', function () { self.onRewardCopy(); });

        // Lyssnare (knappar)
        if (this.backBtn) this.backBtn.addEventListener('click', function () { self.back(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); });
        if (rb) rb.addEventListener('click', function () { self.restart(); });
        this.querySelectorAll('[data-pq-close]').forEach(function (b) { b.setAttribute('aria-label', self.t('close')); b.addEventListener('click', function () { self.close(); }); });
        if (this.overlay) this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(); });
        // Stang quizet om besokaren visar kopintention medan det ar oppet.
        document.addEventListener('on:popups:block', function () { if (self.opened) self.close(); });
        this.addEventListener('keydown', function (e) { self.onKeydown(e); });

        // Alternativ
        this.qSteps.forEach(function (step) {
          var multi = step.getAttribute('data-select-type') === 'multi';
          step.querySelectorAll('[data-pq-opt]').forEach(function (opt) {
            opt.addEventListener('click', function () { self.onOption(step, opt, multi); });
          });
        });

        if (this.shouldShow()) this.setupTrigger();
      }

      t(k) { return (this.i18n && this.i18n[k]) || ''; }
      tp(k) { return this.t(k).replace(/\{p\}/g, this.rewardPercent); }

      /* ---------- Bygg frågesteg från JSON ---------- */
      buildSteps() {
        var body = this.querySelector('[data-pq-body]');
        var result = this.resultStep;
        if (!body || !this.quiz || !this.quiz.questions) return;
        var frag = document.createDocumentFragment();
        this.quiz.questions.forEach(function (q, qi) {
          if (!q || !q.opts || !q.opts.length) return;
          var fs = document.createElement('fieldset');
          fs.className = 'pq__step';
          fs.setAttribute('data-pq-step', '');
          fs.setAttribute('data-step-index', qi + 1);
          fs.setAttribute('data-select-type', q.type === 'multi' ? 'multi' : 'single');
          if (q.showIf) fs.setAttribute('data-show-if', q.showIf);
          fs.hidden = true;
          var leg = document.createElement('legend'); leg.className = 'pq__q'; leg.textContent = q.q || ''; fs.appendChild(leg);
          if (q.help) { var hp = document.createElement('p'); hp.className = 'pq__help'; hp.textContent = q.help; fs.appendChild(hp); }
          var opts = document.createElement('div'); opts.className = 'pq__opts';
          q.opts.forEach(function (o) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'pq__opt';
            b.setAttribute('data-pq-opt', '');
            b.setAttribute('data-tags', (o.t || '').toLowerCase());
            b.setAttribute('aria-pressed', 'false');
            if (o.img) { var ic = document.createElement('span'); ic.className = 'pq__opt-ic'; var im = document.createElement('img'); im.className = 'pq__opt-img'; im.src = o.img; im.alt = ''; im.setAttribute('aria-hidden', 'true'); im.loading = 'lazy'; ic.appendChild(im); b.appendChild(ic); }
            var lab = document.createElement('span'); lab.className = 'pq__opt-lab'; lab.textContent = o.l || ''; b.appendChild(lab);
            var chk = document.createElement('span'); chk.className = 'pq__opt-check'; chk.setAttribute('aria-hidden', 'true'); b.appendChild(chk);
            opts.appendChild(b);
          });
          fs.appendChild(opts);
          var hint = document.createElement('p'); hint.className = 'pq__hint'; hint.setAttribute('data-pq-hint', ''); hint.hidden = true; fs.appendChild(hint);
          frag.appendChild(fs);
        });
        body.insertBefore(frag, result);
      }

      /* ---------- Sidstyrning + frekvens ---------- */
      shouldShow() {
        if (!this.total) return false;
        var pt = this.dataset.pageType || '';
        if (pt === 'cart' || pt === 'cart_drawer' || pt.indexOf('checkout') !== -1) return false;
        var target = this.dataset.pageTarget || 'all';
        if (target === 'home' && pt !== 'index') return false;
        if (target === 'product' && pt !== 'product') return false;
        if (target === 'collection_product' && pt !== 'collection' && pt !== 'product') return false;

        var freq = this.dataset.frequency || 'session';
        try {
          if (freq === 'session') { if (sessionStorage.getItem('on_quiz_session')) return false; }
          else if (freq === 'days') {
            var prev = parseInt(localStorage.getItem('on_quiz_seen'), 10);
            var days = parseInt(this.dataset.frequencyDays, 10) || 7;
            if (prev && (Date.now() - prev) < days * 86400000) return false;
          }
        } catch (e) {}
        return true;
      }
      markSeen() {
        try { sessionStorage.setItem('on_quiz_session', '1'); localStorage.setItem('on_quiz_seen', String(Date.now())); } catch (e) {}
      }

      /* ---------- Trigger ---------- */
      setupTrigger() {
        var self = this, mode = this.dataset.triggerMode || 'time';
        if (mode === 'immediate') { setTimeout(function () { self.open(); }, 0); return; }
        if (mode === 'time') { var d = parseInt(this.dataset.triggerDelay, 10); if (isNaN(d)) d = 8; setTimeout(function () { self.open(); }, d * 1000); return; }
        if (mode === 'scroll') {
          var pct = parseInt(this.dataset.triggerScroll, 10) || 40;
          var onScroll = function () {
            var h = document.documentElement.scrollHeight - window.innerHeight;
            var p = h > 0 ? (window.scrollY / h) * 100 : 100;
            if (p >= pct) { window.removeEventListener('scroll', onScroll); self.open(); }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          return;
        }
        if (mode === 'exit') {
          var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
          if (!canHover) { var d2 = parseInt(this.dataset.triggerDelay, 10); if (isNaN(d2)) d2 = 8; setTimeout(function () { self.open(); }, Math.max(d2, 6) * 1000); return; }
          var onOut = function (e) { if (e.clientY <= 0 && !e.relatedTarget) { document.removeEventListener('mouseout', onOut); self.open(); } };
          document.addEventListener('mouseout', onOut);
          return;
        }
      }

      /* ---------- Öppna / stäng ---------- */
      open() {
        // Delad grind: max en popup per session, inga alls efter kopintention.
        // Klick pa quiz-knappen gar via openManual() och forbigar grinden.
        if (!this._manual && window.onPopupGate && !window.onPopupGate.canShow('quiz')) return;
        if (window.onPopupGate) window.onPopupGate.markShown('quiz');
        if (this.opened || !this.overlay) return;
        this.opened = true;
        this.markSeen();
        this.overlay.hidden = false;
        void this.overlay.offsetWidth;
        this.classList.add('is-open');
        this._prevHtmlOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this._lastFocus = document.activeElement;
        this.show(0);
        var self = this;
        setTimeout(function () { var f = self.modal.querySelector('[data-pq-opt], [data-pq-close]'); if (f) f.focus(); }, 60);
      }
      close() {
        if (!this.opened) return;
        this.opened = false;
        this.markSeen();
        this.classList.remove('is-open');
        document.documentElement.style.overflow = this._prevHtmlOverflow || '';
        var self = this;
        setTimeout(function () { if (!self.opened && self.overlay) self.overlay.hidden = true; }, 300);
        if (this._lastFocus && this._lastFocus.focus) { try { this._lastFocus.focus(); } catch (e) {} }
      }

      /* ---------- Navigering ---------- */
      show(i) {
        this.current = i;
        this.qSteps.forEach(function (s, idx) { s.hidden = idx !== i; });
        var onResult = i >= this.total;
        if (this.resultStep) this.resultStep.hidden = !onResult;
        if (onResult) this.computeResults();

        var prog = this.querySelector('[data-pq-progress]');
        if (prog) prog.style.display = onResult ? 'none' : '';
        var isLast = false, hasPrev = false;
        if (!onResult) {
          var sf = this.stepFlags();
          var visIdx = [];
          for (var v = 0; v < sf.flags.length; v++) { if (sf.flags[v]) visIdx.push(v); }
          var pos = visIdx.indexOf(i); if (pos < 0) pos = 0;
          isLast = pos >= visIdx.length - 1;
          hasPrev = pos > 0;
          if (this.dotsEl) {
            var dh = '';
            for (var d = 0; d < visIdx.length; d++) dh += '<span class="pq__dot' + (d === pos ? ' is-active' : (d < pos ? ' is-done' : '')) + '"></span>';
            this.dotsEl.innerHTML = dh;
          }
          var st = this.querySelector('[data-pq-steptext]');
          if (st) st.textContent = this.t('step').replace('{current}', pos + 1).replace('{total}', visIdx.length);
        }

        if (onResult) {
          if (this.backBtn) this.backBtn.hidden = true;
          if (this.nextBtn) this.nextBtn.hidden = true;
        } else {
          if (this.backBtn) { this.backBtn.hidden = !hasPrev; this.backBtn.textContent = this.t('back'); }
          if (this.nextBtn) { this.nextBtn.hidden = false; this.nextBtn.textContent = isLast ? this.t('see_results') : this.t('next'); }
        }
        var body = this.querySelector('[data-pq-body]'); if (body) body.scrollTop = 0;
      }
      back() {
        var sf = this.stepFlags();
        for (var i = this.current - 1; i >= 0; i--) { if (sf.flags[i]) { this.show(i); return; } }
      }
      next() {
        if (this.current >= this.total) return;
        var step = this.qSteps[this.current];
        if (!this.isAnswered(step)) { this.showHint(step); return; }
        var sf = this.stepFlags();
        for (var i = this.current + 1; i < this.total; i++) { if (sf.flags[i]) { this.show(i); return; } }
        this.show(this.total);
      }
      isAnswered(step) { return !!step.querySelector('[data-pq-opt][aria-pressed="true"]'); }
      showHint(step) {
        var hint = step.querySelector('[data-pq-hint]');
        if (!hint) return;
        var multi = step.getAttribute('data-select-type') === 'multi';
        hint.textContent = multi ? this.t('pick_hint_multi') : this.t('pick_hint_single');
        hint.hidden = false;
      }
      onOption(step, opt, multi) {
        var hint = step.querySelector('[data-pq-hint]'); if (hint) hint.hidden = true;
        if (multi) {
          opt.setAttribute('aria-pressed', opt.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        } else {
          step.querySelectorAll('[data-pq-opt]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          opt.setAttribute('aria-pressed', 'true');
          var self = this;
          setTimeout(function () { self.next(); }, 260);
        }
      }

      /* ---------- Villkorade steg + insamling ----------
         Steg med data-show-if visas bara om något av |-separerade taggarna redan
         valts i TIDIGARE synliga steg. Svar i dolda steg räknas aldrig. */
      stepFlags() {
        var flags = [], collected = [];
        for (var i = 0; i < this.qSteps.length; i++) {
          var step = this.qSteps[i];
          var cond = step.getAttribute('data-show-if') || '';
          var vis = true;
          if (cond) {
            var alts = cond.split('|');
            vis = false;
            for (var k = 0; k < alts.length; k++) { if (collected.indexOf(alts[k].trim()) > -1) { vis = true; break; } }
          }
          flags.push(vis);
          if (vis) {
            step.querySelectorAll('[data-pq-opt][aria-pressed="true"]').forEach(function (opt) {
              (opt.getAttribute('data-tags') || '').split(',').forEach(function (tg) { tg = tg.trim().toLowerCase(); if (tg) collected.push(tg); });
            });
          }
        }
        return { flags: flags, collected: collected };
      }
      collectedTags() { return this.stepFlags().collected; }
      computeResults() {
        var collected = this.collectedTags();
        var genderWanted = collected.filter(function (t) { return t.indexOf('gender:') === 0; });
        var typeWanted = collected.filter(function (t) { return t.indexOf('type:') === 0; });
        var wantWinter = collected.indexOf('season:winter') > -1;
        var wantSummer = collected.indexOf('season:summer') > -1;
        var scoreTags = collected.filter(function (t) { return t.indexOf('gender:') !== 0 && t; });
        var tpls = Array.prototype.slice.call(this.querySelectorAll('[data-pq-card]'));
        var seen = {}, scored = [];
        tpls.forEach(function (tpl, idx) {
          var id = tpl.getAttribute('data-product-id') || ('x' + idx);
          if (seen[id]) return; seen[id] = 1;
          var tags = (tpl.getAttribute('data-tags') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
          if (genderWanted.length) {
            var hasG = false, okG = false;
            tags.forEach(function (t) { if (t.indexOf('gender:') === 0) { hasG = true; if (genderWanted.indexOf(t) > -1) okG = true; } });
            if (hasG && !okG) return;
          }
          // Vald plaggtyp = HÅRT filter (stretch-problem ger aldrig skor)
          if (typeWanted.length) {
            var okT = false;
            tags.forEach(function (t) { if (t.indexOf('type:') === 0 && typeWanted.indexOf(t) > -1) okT = true; });
            if (!okT) return;
          }
          // Säsong = uteslutning: vinterval visar aldrig sommarplagg och tvärtom
          if (wantWinter && !wantSummer && tags.indexOf('season:summer') > -1) return;
          if (wantSummer && !wantWinter && tags.indexOf('season:winter') > -1) return;
          var real = 0;
          scoreTags.forEach(function (t) { if (tags.indexOf(t) > -1) real++; });
          var total = real * 2 + (tags.indexOf('bestseller') > -1 ? 1 : 0);
          scored.push({ tpl: tpl, real: real, total: total, idx: idx });
        });
        scored.sort(function (a, b) { return (b.total - a.total) || (b.real - a.real) || (a.idx - b.idx); });

        var winnerEl = this.querySelector('[data-pq-winner]');
        var altsWrap = this.querySelector('[data-pq-alts-wrap]');
        var altsEl = this.querySelector('[data-pq-alts]');
        var intro = this.querySelector('[data-pq-intro]');
        var nomatch = this.querySelector('[data-pq-nomatch]');
        var also = this.querySelector('[data-pq-also]');
        winnerEl.innerHTML = ''; altsEl.innerHTML = '';
        altsWrap.hidden = true; nomatch.hidden = true; winnerEl.hidden = false; intro.hidden = false;

        var qualifying = scored.filter(function (s) { return s.real > 0; });
        if (qualifying.length) {
          intro.textContent = this.t('result_intro');
          var lead = document.createElement('p'); lead.className = 'pq__perfect'; lead.textContent = this.t('perfect');
          winnerEl.appendChild(lead);
          winnerEl.appendChild(qualifying[0].tpl.content.cloneNode(true));
          var alts = [];
          for (var i = 1; i < qualifying.length && alts.length < this.maxAlts; i++) alts.push(qualifying[i]);
          if (alts.length) {
            altsWrap.hidden = false;
            if (also) also.textContent = this.t('also_like');
            alts.forEach(function (a) { altsEl.appendChild(a.tpl.content.cloneNode(true)); });
          }
          this.showReward(); return;
        }

        // Ingen kvalificerad träff → fallback-produkter
        var fbs = Array.prototype.slice.call(this.querySelectorAll('[data-pq-fallback]'));
        if (fbs.length) {
          intro.textContent = this.t('no_match');
          winnerEl.appendChild(fbs[0].content.cloneNode(true));
          if (fbs.length > 1) {
            altsWrap.hidden = false;
            if (also) also.textContent = this.t('also_like');
            for (var j = 1; j < fbs.length; j++) altsEl.appendChild(fbs[j].content.cloneNode(true));
          }
          this.showReward(); return;
        }

        // Inget alls → no_match + bläddra-länk
        intro.hidden = true; winnerEl.hidden = true; nomatch.hidden = false;
        var nt = this.querySelector('[data-pq-nomatch-txt]'); if (nt) nt.textContent = this.t('no_match');
        this.showReward();
      }
      restart() {
        this.qSteps.forEach(function (step) { step.querySelectorAll('[data-pq-opt]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); }); var h = step.querySelector('[data-pq-hint]'); if (h) h.hidden = true; });
        this.show(0);
      }

      /* ---------- Belöning ---------- */
      showReward() {
        var rw = this.querySelector('[data-pq-reward]');
        var inner = this.querySelector('[data-pq-results-inner]');
        var restart = this.querySelector('[data-pq-restart]');
        if (!this.rewardEnabled || !rw) { if (rw) rw.hidden = true; if (inner) inner.hidden = false; return; }
        rw.hidden = false;
        var form = this.querySelector('[data-pq-reward-form]');
        var done = this.querySelector('[data-pq-reward-done]');
        var lead = this.querySelector('[data-pq-reward-lead]');
        var redeemed = null;
        try { redeemed = localStorage.getItem('on_quiz_reward'); } catch (e) {}
        if (redeemed) {
          if (form) form.hidden = true;
          if (lead) lead.hidden = true;
          this.fillDone(redeemed);
          if (done) done.hidden = false;
          if (inner) inner.hidden = false;
          if (restart) restart.style.display = '';
          return;
        }
        if (done) done.hidden = true;
        if (form) form.hidden = false;
        var gate = this.dataset.rewardGate || 'results_first';
        if (lead) { lead.hidden = false; lead.textContent = this.tp(gate === 'require_email' ? 'reward_lead_gate' : 'reward_lead'); }
        if (inner) inner.hidden = (gate === 'require_email');
        if (restart) restart.style.display = (gate === 'require_email') ? 'none' : '';
      }
      fillDone(code) {
        var c = this.querySelector('[data-pq-reward-code]'); if (c) c.textContent = code;
        var dl = this.querySelector('[data-pq-reward-done-lead]'); if (dl) dl.textContent = this.tp('reward_done_lead');
        var cp = this.querySelector('[data-pq-reward-copy]'); if (cp) cp.textContent = this.t('reward_copy');
        var hn = this.querySelector('[data-pq-reward-hint]'); if (hn) hn.textContent = this.t('reward_hint');
      }
      onRewardSubmit(e) {
        e.preventDefault();
        var self = this;
        var emailEl = this.querySelector('[data-pq-reward-email]');
        var consent = this.querySelector('[data-pq-reward-consent]');
        var err = this.querySelector('[data-pq-reward-err]');
        var btn = this.querySelector('[data-pq-reward-btn]');
        var email = (emailEl && emailEl.value || '').trim();
        function fail(m) { if (err) { err.textContent = m; err.hidden = false; } }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail(this.t('reward_err_email'));
        if (consent && !consent.checked) return fail(this.t('reward_err_consent'));
        if (err) err.hidden = true;
        if (btn) btn.disabled = true;

        var company = this.dataset.klaviyoCompany, list = this.dataset.klaviyoList;
        var finish = function () {
          var code = self.dataset.rewardCode || '';
          try { localStorage.setItem('on_quiz_reward', code); } catch (e) {}
          var form = self.querySelector('[data-pq-reward-form]'); if (form) form.hidden = true;
          var lead = self.querySelector('[data-pq-reward-lead]'); if (lead) lead.hidden = true;
          self.fillDone(code);
          var done = self.querySelector('[data-pq-reward-done]'); if (done) done.hidden = false;
          var inner = self.querySelector('[data-pq-results-inner]'); if (inner) inner.hidden = false;
          var restart = self.querySelector('[data-pq-restart]'); if (restart) restart.style.display = '';
        };
        if (!company || !list) { finish(); return; }

        var payload = { data: { type: 'subscription', attributes: { custom_source: 'Product Quiz', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.ok || r.status === 202) { finish(); }
          else { if (btn) btn.disabled = false; fail(self.t('reward_err')); }
        }).catch(function () { if (btn) btn.disabled = false; fail(self.t('reward_err')); });
      }
      onRewardCopy() {
        var self = this;
        var code = this.dataset.rewardCode || '';
        var cp = this.querySelector('[data-pq-reward-copy]');
        var done = function () { if (cp) { var o = self.t('reward_copy'); cp.textContent = self.t('reward_copied'); setTimeout(function () { cp.textContent = o; }, 1500); } };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
      }

      /* ---------- Tangentbord / fokusfälla ---------- */
      onKeydown(e) {
        if (!this.opened) return;
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var focusables = this.modal.querySelectorAll('button:not([hidden]):not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
        focusables = Array.prototype.slice.call(focusables).filter(function (el) { return el.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
